import Base from './Base';
/**
 * The homepage.
 *
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
export default class Default extends Base{

	init(id,view,lang){
		console.log('Default :: init');
	}
}